import { render } from "./Index.vue?vue&type=template&id=36bbdb37&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-36bbdb37"

export default script